module.exports = __webpack_public_path__ + "img/accessory_shoe_04.7b6bb5a0.svg";